import { SERVICE_TYPE } from "@/constants";
import { FULL_DATE } from "@/constants/dateFormat";
import dayjs from "dayjs";

/**
 * 服务记录查询
 */
export interface RecordInfo {
  /**
   * 服务所属购物村
   */
  shopping_village: number,
  /**
   * 手机号
   */
  phone: string,
  /**
   * 会员号
   */
  user_code: string
  /**
   * 服务项目id
   */
  type: number[],
  /**
   * 关键词
   */
  content: string,
  /**
   * 服务状态
   */
  status: number,
  /**
   * 服务时间区间
   * - start_at 服务开始时间
   * - end_at 服务结束时间
   */
  time_range: string[],
  /**
   * 服务编号
   */
  service_no: string,
}

/**
 * 服务记录查询表单默认值
 */
export const defaultRecordInfo: RecordInfo = {
  shopping_village: null,
  phone: '',
  user_code: '',
  type: [],
  content: '',
  status: null,
  time_range: [dayjs().format(FULL_DATE), dayjs().format(FULL_DATE)],
  service_no: '',
};

/**
 * 现场服务记录详情页面类型
 */
export const SiteDetailPage = {
  [SERVICE_TYPE.LEASE]: 'lease',
  [SERVICE_TYPE.INVOICE]: 'invoice',
  [SERVICE_TYPE.SUGGEST]: 'suggest',
  [SERVICE_TYPE.GIFTWRAP]: 'giftwrap',
  [SERVICE_TYPE.EXPRESS]: 'express',
  [SERVICE_TYPE.THIRD]: 'third',
  [SERVICE_TYPE.DRAWBACK]: 'drawback',
  [SERVICE_TYPE.LOSE]: 'l-and-f',
  [SERVICE_TYPE.LUGGAGE]: 'luggage',
  [SERVICE_TYPE.OTHER]: 'other',
};

/**
 * 预约服务记录详情页面类型
 */
export const SubscribeDetailPage = {
  [SERVICE_TYPE.SHOPPING]: 'shopping',
  [SERVICE_TYPE.PARKING]: 'parking',
  [SERVICE_TYPE.SA]: 'sa',
  [SERVICE_TYPE.LOUNGE]: 'lounge',
};

/**
 * 日常服务类型
 * - 发票，礼品包装，快递，第三方积分登记，退税登记，其他服务登记
 */
export const DailyService = {
  [SERVICE_TYPE.INVOICE]: 'invoice',
  [SERVICE_TYPE.GIFTWRAP]: 'giftwrap',
  [SERVICE_TYPE.EXPRESS]: 'express',
  [SERVICE_TYPE.THIRD]: 'third',
  [SERVICE_TYPE.DRAWBACK]: 'drawback',
  [SERVICE_TYPE.OTHER]: 'other',
};